module.exports = __webpack_public_path__ + "img/charcoal_light.2359e6ab.webp";